import { gql } from 'apollo-angular';

export const GET_PAYMENTS_LIST = gql`
  query ($criteria: PaymentListCriteria!) {
    paymentList(criteria: $criteria) {
      totalResults
      totalAmounts {
        amount
        currency
      }
      results {
        id
        externalId
        concept
        method
        paymentGateway
        amount {
          amount
          currency
        }
        paymentDate
        collector {
          id
          name
        }
        customer {
          id
          name
          externalId
        }
        operations {
          id
          title
          externalId
          amount {
            amount
            currency
          }
        }
      }
    }
  }
`;
